
const elements = Array.from(document.querySelectorAll('[data-eventbrite-embed]'));

document.addEventListener('DOMContentLoaded', () => {
  elements.forEach((el) => {
    const eventId = el.getAttribute('data-eventbrite-embed');
    const containerId = `eventbrite-widget-container-${eventId}`;
    /* eslint-disable-next-line no-param-reassign */
    el.id = containerId;

    window.EBWidgets.createWidget({
      widgetType: 'checkout',
      eventId,
      iframeContainerId: containerId,
      iframeContainerHeight: 425,
      onOrderComplete: () => {},
    });
  });
});
